import { Outlet, useLocation, Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useEventListener } from "ahooks";
import { PhoneOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
// header
import Header from "@/components/Header";
import HeaderAccount from "@/components/HeaderAccount";
import Footer from "@/components/Footer";

// components
import { UserStatusComponent } from "@/components/UserStatus";

import { alonePath, unLoginHeader, publicPath, unFooterPath } from "@/utils/base";

import api from "@/api";
import dataJson from "@/../public/data.json";

import "animate.css";
import "./index.less";

const CSS_PREFIX = "portal";

function Portal() {
  const { home } = dataJson;
  const scrollRef = useRef<any>(null);
  const startPos = useRef<number | null>(null);
  const endPos = useRef<number | null>(null);

  const location = useLocation();
  const { pathname } = location;

  const dispatch = useDispatch();
  const userDataChange = useSelector((state: any) => state.userDataChange);

  const getUserDetail = async () => {
    const res: any = await api.getUserDetail();
    if (res.code === 200) {
      dispatch({
        type: "setUserData",
        payload: res.data,
      });
    }
  };
  // 滚动事件监听
  useEventListener(
    "scroll",
    () => {
      endPos.current = scrollRef.current.scrollTop;
      dispatch({
        type: "setScrollHeight",
        payload: endPos.current,
      });

      if (endPos.current! > startPos.current!) {
        dispatch({
          type: "setScrollDirection",
          payload: "down",
        });
      } else {
        dispatch({
          type: "setScrollDirection",
          payload: "up",
        });

        dispatch({
          type: "setScrollDistance",
          payload: Math.abs(endPos.current! - startPos.current!),
        });
      }

      startPos.current = endPos.current;
    },
    { target: scrollRef }
  );

  useEffect(() => {
    userDataChange > 0 && getUserDetail();
  }, [userDataChange]);

  return (
    <div className={CSS_PREFIX} id={CSS_PREFIX} style={{ minWidth: 1440 }} ref={scrollRef}>
      {/* <Header /> */}
      {/* <HeaderAccount /> */}
      {alonePath.some((path) => pathname.indexOf(path) > -1) ? null : unLoginHeader.some(
          (path) => pathname.indexOf(path) > -1
        ) ? (
        <HeaderAccount />
      ) : (
        <Header />
      )}
      <UserStatusComponent>
        <Outlet />
      </UserStatusComponent>

      {alonePath.some((path) => pathname.indexOf(path) > -1) ||
      unLoginHeader.some((path) => pathname.indexOf(path) > -1) ||
      unFooterPath.some((path) => pathname.indexOf(path) > -1) ? null : (
        <Footer />
      )}
      {alonePath.some((path) => pathname.indexOf(path) > -1) ? null : (
        <Tooltip
          placement="left"
          color="#fff"
          title={
            <div className={`${CSS_PREFIX}-tooltip`}>
              {home.fixed_list.map((item: any) => {
                return (
                  <Link key={item.key} to={`${publicPath}/service_support`}>
                    {item.title}
                  </Link>
                );
              })}
            </div>
          }
        >
          <div className={`${CSS_PREFIX}-phone-div`}>
            <PhoneOutlined style={{ transform: "scaleX(-1)", fontSize: 24 }} />
          </div>
        </Tooltip>
      )}
    </div>
  );
}

export default Portal;
